import { default as ResizeIcon } from '../../icon/icons/IcoGridResize';
const generateReSizeHandle = (testId: string, classes: string[]) => (
  <div data-testid={testId} className={`editor__page__draggable__grid-resize-handle-icon ${classes.join(' ')}`}>
    <ResizeIcon />
  </div>
);

export const availableResizeHandle = {
  bottomRight: generateReSizeHandle('grid_block_resize_handle_test_bottomRight', ['bottom-right']),
  bottomLeft: generateReSizeHandle('grid_block_resize_handle_test_bottomLeft', ['bottom-left']),
  topLeft: generateReSizeHandle('grid_block_resize_handle_test_topLeft', ['top-left']),
  topRight: generateReSizeHandle('grid_block_resize_handle_test_topRight', ['top-right']),
  top: <div data-testid="grid_block_resize_handle_test_top" />,
  bottom: <div data-testid="grid_block_resize_handle_test_bottom" />,
  left: <div data-testid="grid_block_resize_handle_test_left" />,
  right: <div data-testid="grid_block_resize_handle_test_right" />,
};
